import { render, staticRenderFns } from "./HomepageFAQ.vue?vue&type=template&id=37e34620&scoped=true"
import script from "./HomepageFAQ.vue?vue&type=script&lang=js"
export * from "./HomepageFAQ.vue?vue&type=script&lang=js"
import style0 from "./HomepageFAQ.vue?vue&type=style&index=0&id=37e34620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e34620",
  null
  
)

export default component.exports